<mat-form-field appearance="outline" [formGroup]="formGroup" style="margin-bottom: -1.25em; width: 100%;">
  <mat-label>{{config.label}}</mat-label>
  <mat-select [formControl]="controle" [required]="requerido">
    <mat-option>Selecione</mat-option>
    @for (option of (values$ | async); track option) {
      <mat-option [value]="option.value">{{option.text}}</mat-option>
    }
  </mat-select>
</mat-form-field>
